module.exports = __webpack_public_path__ + "img/delete-icon.26399e2a.svg";